import React             from 'react';
import logo              from '../img/logo.png';
import Link              from '@material-ui/core/Link';
import AppBar            from '@material-ui/core/AppBar';
import useScrollTrigger  from '@material-ui/core/useScrollTrigger';
import PropTypes         from 'prop-types';
import Toolbar           from '@material-ui/core/Toolbar';
import FamikarHeaderMenu from './FamikarHeaderMenu'

/**
 * ElevationScroll
 * スクロール位置に応じて子要素の`elevation`を切り替えるヘルパー。
 * @param {object} props コンポーネントプロパティ
 * @param {React.ReactElement} props.children `AppBar` 等の子要素
 * @param {function} [props.window] iframeドキュメント用のwindow取得関数
 * @returns {React.ReactElement} elevation付与後の子要素
 */
export function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });
  
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}
  
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

/**
 * FamikarHeader
 * 画面上部にロゴとメニューを表示するヘッダー。
 * @param {object} props コンポーネントプロパティ
 * @param {string} [props.uid] ログインユーザーUID
 * @param {string} [props.FamilyID] 現在の家族ID
 * @param {boolean} [props.isHome] ホーム画面かどうかのフラグ
 */
export default function FamikarHeader(props) {
  // const [anchorEl, setAnchorEl] = React.useState(false)
  return (
    <React.Fragment>
      <div style={{background:'white', borderBottom: 'inset 2px'}}>
        <ElevationScroll>
          <AppBar  background="white" position="static">
            <Toolbar style={{background:'white'}}>
              <div style={{flexGrow:1,textAlign: 'left', whiteSpace: 'nowrap'}} >
                <Link href='/'>
                  <img src={logo} alt="" style={{margin:3 }}/>
                </Link>
              </div>
              <FamikarHeaderMenu 
                // history={this.props.history} 
                uid={props.uid} 
                FamilyID={props.FamilyID} 
                isHome={props.isHome} />
            </Toolbar>
          </AppBar>
        </ElevationScroll>
      </div>
    </React.Fragment>
  )
}
